import initialState from './partnerBillingTypeInitialState';

export default function partnerBillingTypeReducer(state = initialState) {
    return state;
}